module.exports = __webpack_public_path__ + "img/home-emoji-sm.0ea8e113.png";